/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import ReactPlayerLoader from "@brightcove/react-player-loader";
import { BC_ACCOUNT_ID, BC_PLAYER_ID } from "@helper/getEnvVariables";
import cx from "classnames";
import { ReactElement, RefObject } from "react";

import styles from "./BrightcoveVideo.module.css";

type BrightcoveVideoProps = {
  videoId: string;
  forwardedRef?: React.Ref<HTMLDivElement>;
  videoRef?: RefObject<HTMLDivElement>;
  smallWidget?: boolean;
  onEnded?: () => void;
  nextPlaylist?: () => void;
  className?: string;
  playerId?: string;
};

export function BrightcoveVideo({
  videoId,
  forwardedRef,
  videoRef,
  onEnded,
  nextPlaylist,
  className,
  playerId,
}: BrightcoveVideoProps): ReactElement {
  /**
   * @param {Object} success - The success object containing reference to the player.
   * @param {ReactPlayer} success.ref - Reference to the player.
   */

  interface VideoPlayerRef {
    on(event: string, callback: () => void): void;
    el(): HTMLElement;
  }
  playerId = playerId ? playerId : BC_PLAYER_ID;

  const handleSuccess = function (success: { ref: VideoPlayerRef }) {
    const player = success.ref;
    if (onEnded) {
      player.on("ended", () => {
        onEnded();
      });
    }
    const nextButton = player.el().querySelector(".vjs-next-button");
    if (nextButton) {
      nextButton.addEventListener("click", () => {
        if (nextPlaylist) {
          nextPlaylist();
        }
      });
    }
  };

  return (
    <div
      key={videoId}
      data-testid={videoId}
      className={cx(styles.brightcove, className)}
      ref={forwardedRef}
    >
      <ReactPlayerLoader
        style={{ gridColumn: 1, gridRow: 1 }}
        accountId={BC_ACCOUNT_ID}
        playerId={playerId}
        videoId={videoId}
        videoRef={videoRef}
        onSuccess={handleSuccess}
      />
    </div>
  );
}
